// Lender V2 demo — local "acting as" helpers + shared brand tokens.
export const LENDER_ACTOR_KEY = 'dr_lender_actor';

export const getLenderActor = () => {
  try { return JSON.parse(localStorage.getItem(LENDER_ACTOR_KEY) || 'null'); }
  catch { return null; }
};
export const setLenderActor = (a) => localStorage.setItem(LENDER_ACTOR_KEY, JSON.stringify(a));
export const clearLenderActor = () => localStorage.removeItem(LENDER_ACTOR_KEY);

export const roleLabel = (r) => ({
  loan_officer: 'Loan officer',
  construction_dept: 'Construction dept.',
  bank_admin: 'Bank admin',
}[r] || r);

export const LENDER_BLUE = '#2563E8';
export const LENDER_NAVY = '#16233F';

export const money = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const DRAW_STATUS = {
  submitted: { label: 'Needs review', bg: '#EEF3FF', fg: '#2563E8' },
  lo_approved: { label: 'Awaiting final', bg: '#FFF8EC', fg: '#B45309' },
  sent_back: { label: 'Sent back', bg: '#F1F5F9', fg: '#64748B' },
  approved: { label: 'Approved', bg: '#ECFDF3', fg: '#067647' },
};

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); }
  catch { return '—'; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); }
  catch { return ''; }
};

export const APP_STATUS = {
  in_progress: { label: 'In progress', bg: '#EFF6FF', fg: '#2563E8' },
  needs_docs: { label: 'Needs documents', bg: '#FFF8EC', fg: '#B45309' },
  approved: { label: 'Approved', bg: '#ECFDF3', fg: '#067647' },
  closed: { label: 'Funded', bg: '#F1F5F9', fg: '#334155' },
};

// --- Demo passcode gate (keeps visitors from stumbling into the demo) ---
export const LENDER_DEMO_PASSCODE = 'ohnward2026';
export const LENDER_UNLOCK_KEY = 'dr_lender_unlocked';
export const isLenderUnlocked = () => {
  try { return sessionStorage.getItem(LENDER_UNLOCK_KEY) === '1'; } catch { return false; }
};
export const unlockLender = () => {
  try { sessionStorage.setItem(LENDER_UNLOCK_KEY, '1'); } catch { /* ignore */ }
};

// --- Demo notification inbox (where the borrower-to-lender email lands live) ---
export const LENDER_NOTIFY_KEY = 'dr_lender_notify_email';
export const getLenderNotifyEmail = () => {
  try { return localStorage.getItem(LENDER_NOTIFY_KEY) || ''; } catch { return ''; }
};
export const setLenderNotifyEmail = (e) => {
  try { localStorage.setItem(LENDER_NOTIFY_KEY, e || ''); } catch { /* ignore */ }
};
